import { useState, useEffect } from 'react';
import minBy from 'utils/minBy';

interface Source {
  width: number;
  orientation?: string;
}

export default <T extends Source>(srcSet: T[]) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    function onResize() {
      if (srcSet.length) {
        const orientation =
          window.innerWidth < window.innerHeight ? 'portrait' : 'landscape';

        let index = srcSet.findIndex(
          source =>
            source.width <= window.innerWidth &&
            (source.orientation === orientation ||
              source.orientation !== 'portrait')
        );

        if (index < 0) {
          const min = minBy(
            srcSet.filter(({ width }) => !!width),
            ({ width }) => width
          );

          if (min) {
            index = srcSet.findIndex(({ width }) => width === min.width);
          }
        }

        setIndex(index);
      }
    }

    window.addEventListener('resize', onResize);
    onResize();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return srcSet[index] ?? null;
};
